import { AdditionServicesOptionsState } from '@pages/AdditionalServices/containers/additionServicesOptionsContext';
import {
  AServiceCache,
  AServicePropertyCache,
  AServicePropertyFilterAndOrder,
  AdditionServicesState,
} from '@pages/AdditionalServices/containers/types';

import { ServiceData, SetUpServiceData } from '../../../basket/types';
import { RestoreConfig, serviceRestoreStateGeneratorProcessor } from '../types';

/**
 * StopBeforeServiceCalculationProcessor останавливает восстановление доп. услуг если установлен параметр stopBeforeServiceCalculation.
 * Необходимо для выхода если восстановление происходит из хранилища браузера.
 */
export class StopBeforeServiceCalculationProcessor
  implements serviceRestoreStateGeneratorProcessor
{
  /**
   * restore выполняет восстановление стейтов. Возвращает все стейты.
   * @param setUpServiceData
   * @param _
   * @param additionalServiceState
   * @param optionsState
   * @param serviceCacheState
   * @param servicePropertyCacheState
   * @param servicePropertyFilterAndOrderState
   */
  async restore(
    _: SetUpServiceData,
    __: (SetUpServiceData | ServiceData)[],
    additionalServiceState: AdditionServicesState,
    optionsState: AdditionServicesOptionsState,
    serviceCacheState: AServiceCache,
    servicePropertyCacheState: AServicePropertyCache,
    servicePropertyFilterAndOrderState: AServicePropertyFilterAndOrder,
    restoreConfig: RestoreConfig
  ) {
    return {
      isValid: !restoreConfig.stopBeforeServiceCalculation,
      additionalServiceState,
      optionsState,
      serviceCacheState,
      servicePropertyCacheState,
      servicePropertyFilterAndOrderState,
    };
  }
}
